import React from 'react';
import { Container, Row, Col, Card, Table, ProgressBar } from "react-bootstrap";
import DashboardSideNav from '../components/dashboardSidenav';
import DashboardHeader from '../components/dashboardHeader';
import Statistics from '../components/statistics';
import SavingsPlan from '../components/savingsPlan';
import DashboardSummary from '../components/dashboardSummery';

const SavingsPlanPage = () => {
    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <DashboardSideNav />

            {/* Main Content */}
            <div className="main-content">
                <DashboardHeader />

                <Container fluid>
                    <Row>
                        {/* Left Column */}
                        <Col lg={9}>
                            <DashboardSummary />
                            <SavingsPlan />
                        </Col>

                        {/* Right Column */}
                        <Col lg={3}>
                            <Statistics preview={true} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
};

export default SavingsPlanPage;
